var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-2",attrs:{"fab":"","x-small":"","depressed":"","color":_vm.ledColor,"title":_vm.ledTitle}},[_vm._v(_vm._s(_vm.ledText))])
}
var staticRenderFns = []

export { render, staticRenderFns }